
class GTagController {
    allConsentGranted = () => {
        // @ts-ignore
        window.dataLayer.push('consent', 'update', {
          'ad_user_data': 'granted',
          'ad_personalization': 'granted',
          'ad_storage': 'granted',
          'analytics_storage': 'granted'
        });
      }

    consentGrantedAdStorage = () => {
        // @ts-ignore
        window.dataLayer.push('consent', 'update', {
          'ad_storage': 'granted',
          'analytics_storage': 'granted'
        });
    }

    registerInited = () => {
        // @ts-ignore
        gtag('event', 'register', {
            type: 'REGISTERED'
        });
    }

    startChat = () => {
        // @ts-ignore
        gtag('event', 'message', {
            type: 'SENT_MESSAGE'
        });
    }

    paymentInited = () => {
        // @ts-ignore
        gtag('event', 'lead', {
            type: 'PAID'
        });
        // @ts-ignore
        gtag('event', 'conversion', {
            'send_to': 'AW-16676258209/wyzzCL_w2dYbEKGD7o8-',
            'value': 1.0,
            'currency': 'USD',
            'transaction_id': ''
        });
        // @ts-ignore
        fbq('track', 'Lead');
    }
}

export { GTagController }